import script from "./VVVLoginNew.vue?vue&type=script&setup=true&lang=js"
export * from "./VVVLoginNew.vue?vue&type=script&setup=true&lang=js"

import "./VVVLoginNew.vue?vue&type=style&index=0&id=e795e818&lang=css"
import "./VVVLoginNew.vue?vue&type=style&index=1&id=e795e818&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e795e818"]])

export default __exports__